/* Constants */
import {
  CATEGORY_PRODUCT_PAGE_NAME,
  UNIQUE_PATHS_OF_CATEGORY,
} from '@/constants/uniquePathsOfCategory'

export default defineNuxtRouteMiddleware(({ name, path, query }) => {
  if (path in UNIQUE_PATHS_OF_CATEGORY) {
    const redirectedRoute = path as keyof typeof UNIQUE_PATHS_OF_CATEGORY

    return navigateTo(
      { path: UNIQUE_PATHS_OF_CATEGORY[redirectedRoute], query },
      {
        redirectCode: 301,
      },
    )
  }

  // Если маршрут соответсвует /:categories()/:product() и не входит в список категорий - отдаем 404
  // P.s предотвращает ошибку, когда открывалась пустая страница по рандомному адресу с 2 вложениями (например: /asd/dsa/)
  if (CATEGORY_PRODUCT_PAGE_NAME === name) {
    throw createError({
      statusCode: 404,
      statusMessage: 'Page Not Found',
    })
  }
})
